import { Field, ID, InputType, Int } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { Project } from '../Project'
import type { IAction } from '../../action/IAction'

@InputType()
export class SortProjectTasksArgs extends ActionArgs {
  @Field(() => ID)
  projectId: string

  @Field(() => ID)
  taskId: string

  @Field(() => Int)
  sortIndex: number
}

export interface ISortProjectTasks extends IAction<Project, SortProjectTasksArgs> {}
